module.exports = __webpack_public_path__ + "static/media/mail-read-filled.2687e9f0.svg";